import Big from 'big.js'

const isNumeric = (value: string | number) => {
  if (value !== undefined && value !== null) {
    try {
      Big(value)
      return true
    } catch {
      return false
    }
  } else {
    return false
  }
}

export default isNumeric
